import LoadingLogo from "components/LoadingLogo";

export default function LoadingLayout() {
	return (
		<div className="h-full w-full flex items-center justify-center">
			<LoadingLogo />
		</div>
	);
}
